export function downloadCsv(filename: string, rows: Record<string, unknown>[]) {
  if (rows.length === 0) return
  const first = rows[0]
  if (first === undefined) return
  const headers = Object.keys(first)
  const escape = (val: unknown) => {
    let str = String(val ?? '')
    // A cell starting with one of these is a formula to Excel and Sheets: a
    // piece titled "=HYPERLINK(...)" would become a live link in whoever opens
    // the export. The apostrophe makes it text, and both hide it.
    if (/^[=+\-@\t\r]/.test(str)) str = `'${str}`
    if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
      return `"${str.replace(/"/g, '""')}"`
    }
    return str
  }
  const lines = [
    headers.map(escape).join(','),
    ...rows.map((row) => headers.map((h) => escape(row[h])).join(',')),
  ]
  const csv = lines.join('\n')
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
